import { useState, useRef, useEffect } from "react";
import { FiMoreVertical } from "react-icons/fi";
import Config from "../../../Config";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Menu = ({
    setIsChangeRoom,
    e,
    setInitiateEviction,
    data,
    setIsCancelEviction,
    setIsEvictNow,
    selectedData,
    setSelectedData,
    setIsCancelReservation,
    setIsRentalCycle,
    setIsExtendStay,
    isReassign,
    setIsReassignTenant,
    setIsDeleteTenantModal,
    setIsViewNotes,
    setIsChangeOccupancy
}) => {

    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const tenantId = data?.data?.id;
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleEvict = () => {
        setIsOpen(false);
        setInitiateEviction(true);
    };

    const handleRoomChange = () => {
        setIsOpen(false);
        setIsChangeRoom(true);
    };
    const handleRentalCycle = () => {
        setIsOpen(false);
        setIsRentalCycle(true);
        setSelectedData(data);
    };
    const handleEvictNow = (data) => {
        setIsOpen(false);
        setIsEvictNow(true);
        setSelectedData(data);
    };

    const handleCancelEviction = (data) => {
        setIsCancelEviction(true);
        setIsOpen(false);
        setSelectedData(data);
    };

    const handleCancelReservation = (data) => {
        setIsCancelReservation(true);
        setIsOpen(false);
        setSelectedData(data);
    };
    const handleExtendStay = (data) => {
        setIsExtendStay(true);
        setIsOpen(false);
        setSelectedData(data);
    };
    const handleReassignTenant = (data) => {
        setIsReassignTenant(true);
        setIsOpen(false);
        setSelectedData(data);
    };
    const handleDeleteTenant = (data) => {
        setIsDeleteTenantModal(true);
        setIsOpen(false);
        setSelectedData(data);
    };
    const notes = (data) => {
        setIsViewNotes(true);
        setIsOpen(false);
        setSelectedData(data?.data);
    };
    const changeOccupancy = (data) => {
        setIsChangeOccupancy(true);
        setSelectedData(data);
        setIsOpen(false);

    };

    const handleSendBookingLink = () => {
        if (!data?.data?.bookingMessage) {
            toast.error("Booking link is not available");
            return;
        }

        if (!data?.data?.mobile) {
            toast.error("Mobile number is not available");
            return;
        }

        const encodedMsg = encodeURIComponent(data.data.bookingMessage);
        const url = `https://wa.me/+91${data.data.mobile}?text=${encodedMsg}`;
        window.open(url, "_blank");
    };

    const handleDelete = () => {
        setIsOpen(false);
    };

    return (
        <div className="relative inline-block" ref={menuRef}>
            {/* {e != 1 && */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2 rounded-full hover:bg-gray-200"
            >
                <FiMoreVertical className="text-2xl" />
            </button>
            {/* } */}
            {isOpen && (
                <div className="absolute right-0 mt-2 w-60 bg-white border rounded-lg shadow-lg z-50">
                    <ul className="py-2 text-gray-700">
                        {data?.data?.status === Config.TENANT_STATUS.OCCUPIED && (
                            <>
                                <li
                                    onClick={handleEvict}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                >
                                    Initiate Eviction
                                </li>
                                {/* <li
                                    onClick={handleRoomChange}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                >
                                    Change Room/Property
                                </li> */}
                            </>
                        )}
                        {data?.data?.status !== Config.TENANT_STATUS.MOVING_OUT ||
                            (data?.data?.occupancy?.stayType === 2 && (
                                <li
                                    onClick={() => handleRentalCycle(data)}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                >
                                    Change Rental Cycle
                                </li>
                            ))}
                        {data?.data?.status === Config.TENANT_STATUS.RESERVED && (
                            <>

                                <li
                                    onClick={() => handleCancelReservation(data)}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                >
                                    Cancel Reservation
                                </li>
                            </>
                        )}
                        {data?.data?.status === Config.TENANT_STATUS.MOVING_OUT && (
                            <>
                                <li
                                    onClick={() => handleCancelEviction(data)}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                >
                                    Cancel Eviction
                                </li>
                                <li
                                    onClick={() => handleExtendStay(data)}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                >
                                    Extend Stay
                                </li>
                                <li
                                    onClick={() => handleEvictNow(data)}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                >
                                    Evict Now
                                </li>
                            </>
                        )}
                        {e != 1 && (
                            <><li
                                onClick={handleRoomChange}
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                            >
                                Change Room/Property
                            </li><li
                                onClick={() => navigate(`/tenant-attendance/${tenantId}`, {
                                    state: {
                                        tenantName: data.data.name,
                                    },
                                })}
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                            >
                                    Tenant Attendance
                                </li>
                                {data?.data?.bookingMessage && (
                                    <li
                                        onClick={handleSendBookingLink}
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                    >
                                        Share Booking Link
                                    </li>
                                )}
                                {data?.data?.isMultipleOccupancy && (
                                    <li
                                        onClick={() => changeOccupancy(data)}
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                    >
                                        Consolidate Beds
                                    </li>
                                )}
                            </>
                        )}

                        {e == 1 && (
                            <><li
                                onClick={() => handleReassignTenant(data)}
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                            >
                                Reassign Tenant
                            </li><li
                                onClick={() => handleDeleteTenant(data)}
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                            >
                                    Delete Tenant
                                </li></>
                        )}
                        <li
                            onClick={() => notes(data)}
                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                        >
                            Notes
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default Menu;
